export default "__VITE_ASSET__B4I2h6eV__"